import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { IAppointmentData, IAppointmentStatusLogs } from 'src/app/models/IAppointmentDetails';
import { IAttributes } from 'src/app/models/IAttributes';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';
import { IprocedureCode, IProcedureCodes } from 'src/app/models/IProcedureCodes';
import { ProceduresDialogComponent } from '../procedures-dialog/procedures-dialog.component';
import { I } from '@angular/cdk/keycodes';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
declare let $: any;
@Component({
  selector: 'app-procedure-logs',
  templateUrl: './procedure-logs.component.html',
  styleUrls: ['./procedure-logs.component.css']
})
export class ProcedureLogsComponent implements OnInit {

  procedurelogForm: FormGroup;
  postComment: Array<IAppointmentStatusLogs> = [];
  postComment_Master: Array<IAppointmentStatusLogs> = [];
  appointmentLogs: any = [];
  submitted: Boolean = false;
  public id = 0;
  appStatusList: IAttributes[] = [];
  selectedAppStatus: IAttributes;
  public selectedAppId: string = '';
  constructor(private formBuilder: FormBuilder,
    private schedulerservice: SchedularServiceService,
    private sharedService: SharedService,
    private _toasterService: ToastrService,
    private procService: ProcedureCodesService,
    private _datePipe: DatePipe, public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProcedureLogsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedAppId = this.data.apptData.Id;

  }

  ngOnInit() {
    $(document).click(function (event) {
      if (event.target.id != "allproviderfocus") {
        if (event.target.id != "procedurefocus") {
          var container = $("#procedurefocushide");
          if (!container.is(event.target) && !container.has(event.target).length) {
            container.hide();
          }
          if (event.target.id == "providersfocus") {
            $("#providersfocushide").show();
          }
        }
        if (event.target.id != "providersfocus") {
          var container = $("#providersfocushide");
          if (!container.is(event.target) && !container.has(event.target).length) {
            container.hide();
          }
          if (event.target.id == "procedurefocus") {
            $("#procedurefocushide").show();
          }
        }
      }
    });

    this.createForm();
    this.getActiveProcedures();
    this.getAppointmentLogs();

  }


  async getActiveProcedures() {
    this.procService.getActiveProcedures(this.data.apptData.patientId).subscribe(async data => {
      await data;
      this.activeProcedures = data;
      if (this.selectedAppId != null && this.selectedAppId != undefined && this.selectedAppId != 'undefined')
        this.getAppointmentbyId(data);
    });
  }

  locationdisable = false;
  selectedAppointment: IAppointmentData;
  getAppointmentbyId(procedureData: any) {

    this.schedulerservice.getAppointmentbyId(this.selectedAppId).subscribe(
      results => {
        this.selectedAppointment = results;
        var procedure = this.selectedAppointment.ProcedureName;
        this.chk = this.selectedAppointment.ProcedureName;
        this.Selectedcode = this.selectedAppointment.ProcedureName;
        var procedure_array = procedure.split('#');
        if (procedure_array[0] != "" && procedureData != null) {
          if (procedureData.length == 0 && procedure_array.length > 0) {
            var obj: IprocedureCode;
            procedure_array.forEach(element => {
              obj = {
                cptMasterId: '',
                categoryId: null,
                categoryName: '',
                regionid: null,
                customerdescription: element,
                cliniciandescription: '',
                cptCode: '',
                icdCode: '',
                cptId: null,
                createdBy: '',
                createdOn: null,
                modifiedBy: '',
                aliasName: '',
                modifiedOn: null,
                procedureName: element,
                diagnosis: '',
                categoryCodes: null,
                icdCodes: null,
                selected: false
              }
              this.activeProcedures.push(obj)
            });
          }
        }

        const procdureSplit = this.selectedAppointment.ProcedureName.split('#');
        var obj1: IprocedureCode;
        if (procdureSplit[0] != '' && procdureSplit) {
          for (var j = 0; j < procdureSplit.length; j++) {
            var lst = this.activeProcedures.filter(y => y.customerdescription === procdureSplit[j]);
            if (lst.length === 0) {
              obj1 = {
                cptMasterId: '',
                categoryId: null,
                categoryName: '',
                regionid: null,
                customerdescription: procdureSplit[j],
                cliniciandescription: '',
                cptCode: '',
                icdCode: '',
                cptId: null,
                createdBy: '',
                createdOn: null,
                modifiedBy: '',
                aliasName: '',
                modifiedOn: null,
                procedureName: procdureSplit[j],
                diagnosis: '',
                categoryCodes: null,
                icdCodes: null,
                selected: false
              }
            }
            else {

            }
            if (obj1)
              this.activeProcedures.push(obj1);
            obj1 = null;
          }
        }


        procdureSplit.forEach(x => {
          var i = 0;
          this.activeProcedures.forEach(y => {
            if (y.customerdescription == x) {
              this.activeProcedures[i].selected = true;
            }
            i = i + 1;
          });
        });
        for (var i = 0; i < procdureSplit.length; i++) {
          procdureSplit[i] = procdureSplit[i].replace(/^\s*/, "").replace(/\s*$/, "");
          this.procedurelogForm.patchValue({
            FinanceCenter: procdureSplit,
          });
        }

      });
  }


  getAppointmentLogs() {
    this.appStatusList = [];
    this.selectedAppStatus = null;
    this.schedulerservice.GetAppointmentProcedureLogs(this.data.apptData.Id).subscribe(result => {
      this.appointmentLogs = [];
      if (result != null) {
        this.appointmentLogs = result.filter(i => i.appointmentId.toLowerCase() == this.data.apptData.Id.toLowerCase());
        result.filter(i => i.appointmentId.toLowerCase() == this.data.apptData.Id.toLowerCase())
          .forEach(element => {
            var replaceHashtag = element.ProcedureName.replace(/#/g, ", ");
            this.postComment_Master.push({
              commentId: this.id++,
              currentDate: element.appDate,
              createdDate: this._datePipe.transform(element.createdDate, "MM/dd/yyyy hh:mm a").toString(),
              commentTxt: element.ProcedureName,
              providerName: element.providerName,
              displayComments: replaceHashtag,
            });
          })

        // if (result.length == 1) {
        //   if (result[0].ProcedureName == '') {
        //     this.postComment_Master = null
        //   }
        // }

        if (this.appointmentLogs.length > 0)
          this.postComment = this.postComment_Master;
      }
    })

  }
  getAppointmentStatusList() {
    this.sharedService.getAttributesById(Defaults.Appointment_type).subscribe(
      (app: IAttributes[]) => {

        this.appStatusList = app;
        this.appStatusList = this.appStatusList.filter(i => i.attributeName == "Confirmed" || i.attributeName == "Cancelled" || i.attributeName == "Rescheduled")
        let selectedAttribltes = "";
        if (this.appointmentLogs.length > 0)
          selectedAttribltes = "," + this.appointmentLogs.map((i: any) => i.appStatus.toLocaleLowerCase().trim()).join(",") + ",";
        this.appStatusList = this.appStatusList.filter(i => selectedAttribltes.indexOf("," + i.attributeName.toLocaleLowerCase().trim() + ",") > -1);
        if (this.appStatusList.length > 0) {
          var currentStatus = this.appStatusList.filter(i => i.attributeName == this.data.apptData.status);
          if (currentStatus && currentStatus.length > 0)
            this.selectedAppStatus = currentStatus[0];
          else
            this.selectedAppStatus = this.appStatusList[0];

          this.fnShowSelectedComments();
        }
      },
      (err: any) => console.log(err));

  }
  fnShowSelectedComments() {

    this.postComment = this.postComment_Master.filter(i => i.appStatus == this.selectedAppStatus.attributeName);
    if (this.selectedAppStatus.attributeName.toUpperCase() == "CONFIRMED") {
      this.procedurelogForm.controls["titleA"].setValue("Confirmed via Phone");
      this.procedurelogForm.controls["titleB"].setValue("Confirmed via SMS");
      this.procedurelogForm.controls["headerText"].setValue("Confirmed");

    }
    else if (this.selectedAppStatus.attributeName.toUpperCase() == "CANCELLED") {
      this.procedurelogForm.controls["titleA"].setValue("Cancelled by Provider");
      this.procedurelogForm.controls["titleB"].setValue("Cancelled by Patient");
      this.procedurelogForm.controls["headerText"].setValue("Appointment Cancellation");

    }
    else if (this.selectedAppStatus.attributeName.toUpperCase() == "RESCHEDULED") {
      this.procedurelogForm.controls["titleA"].setValue("Rescheduled by Provider");
      this.procedurelogForm.controls["titleB"].setValue("Rescheduled by Patient");
      this.procedurelogForm.controls["headerText"].setValue("Rescheduled");

    }
    else {
      this.procedurelogForm.controls["titleA"].setValue("");
      this.procedurelogForm.controls["titleB"].setValue("");
      this.procedurelogForm.controls["headerText"].setValue(this.selectedAppStatus.attributeName);
    }


  }
  onstatusMenuItemClick(element) {
    this.selectedAppStatus = element;
    this.fnShowSelectedComments();
  }


  createForm() {
    this.procedurelogForm = this.formBuilder.group({
      FinanceCenter: ['',],
      radtitle: ['1', [Validators.required]],
      titleA: [''],
      titleB: [''],
      headerText: ['']
    });
  }
  changeradiobtn(type) {
    //this.procedurelogForm.controls['radtitle'].setValue(type);

  }
  get formFields() {
    return this.procedurelogForm.controls;
  }
  onSubmit() {
    this.submitted = true;
    if (this.procedurelogForm.invalid) {
      return false;
    }
    else {

      this.addCommentstoDB();
    }
    //this.submitted = false;
  }

  addCommentstoDB() {
    // let CommentText = this.formFields.radtitle.value == "1" ? this.formFields.titleA.value.toString() : this.formFields.titleB.value.toString();
    // CommentText = CommentText.trim().toLowerCase() + "(" + this.formFields.FinanceCenter.value.toString().trim().toLowerCase() + ")";
    // if (this.postComment.filter(i => i.commentTxt.trim().toLowerCase() == CommentText).length > 0) {
    //   this._toasterService.error("Status log already added ");
    //   return false;
    // }


    const appointmentLogObj: IAppointmentStatusLogs = {
      appointmentId: this.data.apptData.Id.toString(),
      //appStatus: this.selectedAppStatus.attributeId.toString(),
      createdBy: sessionStorage.getItem("userId").toString(),
      // reason: this.formFields.radtitle.value == "1" ? this.formFields.titleA.value.toString() : this.formFields.titleB.value.toString(),
      note: this.Selectedcode.toString(),
      location: sessionStorage.getItem("LocationId")
    };

    let appointmentLogObjList: IAppointmentStatusLogs[] = [];
    appointmentLogObjList.push(appointmentLogObj);
    this.schedulerservice.AddAppointmentProcedureLogs(appointmentLogObjList).subscribe(result => {
      if (result.toLowerCase().indexOf("successfully")) {
        this.postComment = [];
        this.postComment_Master = [];
        this.getAppointmentLogs();
        this.procedurelogForm.controls['FinanceCenter'].setValue("");
        this._toasterService.success(result);
        //this.activeProcedures = [];
        this.submitted = false;
      }
      else
        this._toasterService.error(result);
    })

  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
  public activeProcedures: IprocedureCode[] = [];
  OpenProcedures() {
    sessionStorage.setItem("patientId", this.data.apptData.patientId);
    const dialogRef = this.dialog.open(ProceduresDialogComponent, {
      width: '1200px',
      height: 'auto',
      data: { headerText: 'Add New Patient Procedures', notesType: 0 }
    });
    dialogRef.afterClosed().subscribe(result => {
      sessionStorage.removeItem("patientId");
      if (result && result != undefined) {
        if (result.procedureName !== '' && result.procedureName !== undefined && result.procedureName !== null) {
          var sepListProduce = this.activeProcedures.filter(x => x.customerdescription == result.procedureName);
          if (sepListProduce.length > 0) {
            var selectedProcedures = this.procedurelogForm.value.FinanceCenter;

          } else {
            var tempProcude: IprocedureCode = new IprocedureCode();
            tempProcude.customerdescription = ((result.procType == null ? "" : result.procType + " ") + result.procedureName + ((result.procSide == null || result.procSide == '') ? "" : "(" + result.procSide + ")")
              + ((result.procLevels == null || result.procLevels == '') ? "" : "(" + result.procLevels + ")"));
            this.activeProcedures.push(tempProcude);
          }
        }
      }
    });
  }

  onSelectionChanged(event, type: string) {
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
        $('#procedurefocushide').show();
      }
    }, 100);
  }

  focusOutFunctionprocedure(evn) {
    if (evn.keyCode === 9) {
      $('#procedurefocushide').hide()
    } else if (evn.keyCode === 40 && evn.target.id == "procedurefocus") {
      $('#procedureistoption0').focus();
    }
  }

  public Selectedcode: string = "";
  public chk: string = "";
  public removechk: string = "";
  selectedProcedures(index, element) {
    var code = element;
    var test = this.Selectedcode.includes(code);
    if (test == true) {
      this.Selectedcode = this.Selectedcode.replace(code, '');
      this.Selectedcode = this.Selectedcode.replace(/##/g, '#');//replace("##", '#');
      this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
      if (this.Selectedcode.charAt(0) == ",") {
        this.Selectedcode = this.Selectedcode.substring(1);
      }
      if (this.Selectedcode.charAt(0) == "#") {
        this.Selectedcode = this.Selectedcode.substring(1);
      }
      if (this.Selectedcode.endsWith("#")) {
        this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 1);
      }
      if (this.Selectedcode == "#") {
        this.Selectedcode = "";
      }
    } else {
      if (this.chk != "") {
        this.Selectedcode = this.Selectedcode.concat("#" + code);
        this.Selectedcode = this.Selectedcode.replace(/##/g, '#');//.replace("##", '#');
        this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
        if (this.Selectedcode.charAt(0) == ",") {
          this.Selectedcode = this.Selectedcode.substring(1);
        }
        if (this.Selectedcode.charAt(0) == "#") {
          this.Selectedcode = this.Selectedcode.substring(1);
        }
        if (this.Selectedcode.endsWith("#")) {
          this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 1);
        }
        if (this.Selectedcode == "#") {
          this.Selectedcode = "";
        }
      } else {
        this.chk = code;
        this.Selectedcode = code;
        if (this.Selectedcode == "#") {
          this.Selectedcode = "";
        }
      }
    }
    this.procedurelogForm.controls.FinanceCenter.setValue('');
    this.procedurelogForm.patchValue({
      FinanceCenter: this.Selectedcode.replace(/#/g, ',')
    })

    // if (this.procedurelogForm.value.FinanceCenter != "") {
    //   this.submitted = false;
    // } else {
    //   this.submitted = true;
    // }
  }
}
